var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,21.93c2.89-4.31,2.91-6.19,5.01-9.76,.26-.5,.78-.82,1.35-.82h8.19c.41,.01,.8,.17,1.08,.47l11.19,11.52c.56,.58,.57,1.5,.02,2.09l-6.08,6.5c-.6,.64-1.62,.64-2.22-.01l-2.49-2.7v23.17c0,.84-.68,1.51-1.51,1.51H17.46c-.84,0-1.51-.68-1.51-1.51V29.23l-2.49,2.7c-.6,.64-1.62,.65-2.22,.01l-6.08-6.5c-.55-.59-.55-1.51,.02-2.09l11.2-11.55c.29-.29,.68-.46,1.08-.46h8.19c.57,0,1.08,.31,1.34,.82,2.12,3.72,2.76,6.63,5.01,9.78h0Zm-7.21-7.55h-6.7l-9.75,10.05,3.98,4.26,4.01-4.36c.93-1.02,2.63-.35,2.63,1.03v25.54h26.05V25.37c0-1.38,1.7-2.04,2.63-1.03l4.01,4.36,3.98-4.26-9.75-10.04h-6.7c-2.1,4.26-2.84,7.43-6.13,10.93-.59,.6-1.57,.6-2.16,0-2.32-2.16-4.1-6.5-6.12-10.94h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop);
export default __webpack_public_path__ + "static/media/icon_top.79a2e48d.svg";
export { ForwardRef as ReactComponent };